var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40.0001C31.046 40.0001 40.0003 31.0458 40.0003 20.0001C40.0003 8.95443 31.046 0.00012207 20.0003 0.00012207C8.95457 0.00012207 0.000259399 8.95443 0.000259399 20.0001C0.000259399 31.0458 8.95457 40.0001 20.0003 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4399 12.2464C35.4111 5.05176 28.2961 4.57764e-05 20.0001 4.57764e-05C14.4772 4.57764e-05 9.4777 2.23903 5.85864 5.85856L10.8672 12.2464H38.4399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.924 27.6813L5.85864 34.1415C9.4777 37.761 14.4772 40 20.0001 40C28.324 40 35.4593 34.9145 38.4707 27.6813H10.924Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34785 14.7103V25.2175H39.3111C39.7597 23.5541 40 21.8053 40 20.0001C40 18.1687 39.7533 16.3953 39.2921 14.7103H4.34785Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85788 5.85786C-1.95259 13.6683 -1.95259 26.3317 5.85788 34.1422C9.08546 30.9147 12.1896 27.8105 20.0001 20L5.85788 5.85786Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51455 15.0276L8.95557 18.4339L12.9499 17.1648L10.4647 20.5392L12.9057 23.9457L8.92854 22.6248L6.44322 25.9992L6.47057 21.8084L2.49323 20.4873L6.48729 19.2183L6.51455 15.0276Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthSudan);
export default __webpack_public_path__ + "static/media/south_sudan.4fc93a762f89f652645f1ad4f32edcc9.svg";
export { ForwardRef as ReactComponent };